import { render } from "./TheLayout.vue?vue&type=template&id=38ad324d&scoped=true"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"

import "./TheLayout.vue?vue&type=style&index=0&id=38ad324d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ad324d"]])

export default __exports__